class NotifyPopup {
    constructor() {
        this.popup = document.querySelector('.waitlist-popup');
        this.closeButton = this.popup.querySelector('.waitlist-popup__close');
        this.form = this.popup.querySelector('.waitlist-popup__form');
        
        this.successPopup = document.querySelector('.success-popup');
        this.successCloseButton = this.successPopup.querySelector('.success-popup__close');

        this.init();
    }

    init() {
        this.closeButton.addEventListener('click', () => this.close());
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') {
                this.close();
                this.closeSuccessPopup();
            }
        });
        this.popup.addEventListener('click', (e) => {
            if (e.target.classList.contains('waitlist-popup__overlay')) this.close();
        });
        
        this.successCloseButton.addEventListener('click', () => this.closeSuccessPopup());
        
        this.form.addEventListener('submit', (e) => this.handleSubmit(e));
    }

    open() {
        this.popup.classList.add('active');
        document.body.style.overflow = 'hidden';
    }

    close() {
        this.popup.classList.remove('active');
        document.body.style.overflow = '';
    }

    showSuccessPopup() {
        this.successPopup.classList.add('active');
    }

    closeSuccessPopup() {
        this.successPopup.classList.remove('active');
    }

    async handleSubmit(e) {
        e.preventDefault();
        let productName = document.querySelector('.product-single__title').innerHTML.trim();
        const userEmail = this.form.querySelector('input[type="email"]').value;

        if(location.href.includes('en-au')) {
            productName += ' AU';
        } else if(location.href.includes('en-ca')) {
            productName += ' CA';
        }

        const response = await fetch(window.Shopify.aws_link, {
            method: 'POST',
            body: JSON.stringify({
                "userEmail": userEmail,
                "productName": productName
            })
        });

        if (response.ok) {
            this.close();
            this.showSuccessPopup();
            this.form.reset();

            setTimeout(() => {
                this.closeSuccessPopup();
            }, 3000);
        } else {
            console.error('Failed to submit form');
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const notifyPopup = new NotifyPopup();
    
    const notifyButtons = document.querySelectorAll('.notify-me-button');
    notifyButtons.forEach(button => {
        button.addEventListener('click', () => notifyPopup.open());
    });
});
